import React from "react";
import { GoalTemplate } from "./goal_template_class";
import { GoalType } from "./goal_type_class";
import {
  AchievementConditionShape,
  GoalTypeShape,
  ObservationGoalShape,
  MeasurementTypeShape,
  SavePayloadShape,
} from "../interfaces/classTypes";
import { Measurement } from "./measurements/measurement";
import { AchievementCondition } from "./achievement_conditions_class";
import { isConstructorDeclaration } from "typescript";

export class ObservationGoalTemplate extends GoalTemplate {
  public achievementCondition: AchievementConditionShape;
  public achievementTarget: number;
  public achievementThreshold: number;
  public measurementId: number;
  public type: GoalTypeShape;

  constructor({
    achievementCondition = null,
    achievementTargetFormatted = null,
    achievementTarget = null,
    achievementThreshold = null,
    continuous = true,
    createdAtFormatted = null,
    description = "",
    hasErrors = false,
    id = null,
    leaderboardEnabled = false,
    measurementId = null,
    name = "",
    occurrenceAmount = null,
    occurrenceFrequency = null,
    user = null,
  }: ObservationGoalShape) {
    let extendedData = {
      continuous: continuous,
      createdAtFormatted: createdAtFormatted,
      description: description,
      hasErrors: hasErrors,
      id: id,
      leaderboardEnabled: leaderboardEnabled,
      name: name,
      occurrenceAmount: occurrenceAmount,
      occurrenceFrequency: occurrenceFrequency,
      user: user,
    };
    super(extendedData);
    this.measurementId = measurementId;
    this.achievementTarget = achievementTargetFormatted
      ? achievementTargetFormatted
      : achievementTarget;
    this.achievementThreshold = achievementThreshold;
    this.type = GoalType.includedGoalTypes().find(
      (type: GoalTypeShape) => type.id == 0
    );
    this.setAchievementCondition(achievementCondition);
  }

  setAchievementCondition(input) {
    if (input == null) {
      this.achievementCondition = input;
    } else {
      let conditionObject = AchievementCondition.includedAchivementConditions().find(
        (condition) =>
          condition.name == (typeof input == "string" ? input : input.name)
      );
      this.achievementCondition = conditionObject;
    }
  }

  checkForEditorErrors(interviewSet) {
    return;
  }

  measurementType() {
    return Measurement.includedMeasurements().find(
      (measurement: MeasurementTypeShape) =>
        measurement.id == this.measurementId
    );
  }

  formatForSave() {
    var payload: SavePayloadShape = {
      name: this.name,
      description: this.description,
      leaderboard_enabled: this.leaderboardEnabled,
      type: this.type.name,
      measurement_id: this.measurementId,
      id: this.id,
      interview_ids: null, // SavePayloadShape does not include interview_ids, it has a interview_set_ids property.
      education_link_ids: null,
      continuous: this.continuous,
      occurrence_amount:
        this.occurrenceAmount == null ? 0 : this.occurrenceAmount,
      occurrence_frequency: this.occurrenceFrequency.name,
      achievement_target: this.achievementTarget,
      achievement_condition: this.achievementCondition.name,
      achievement_threshold: this.achievementThreshold,
      user_id: this.user.id,
    };
    return payload;
  }

  formatForLocalSave() {
    var payload: any = {
      name: this.name,
      createdAtFormatted: this.createdAtFormatted,
      description: this.description,
      leaderboardEnabled: this.leaderboardEnabled,
      type: this.type.name,
      measurementId: this.measurementId,
      interviewIds: null,
      educationLinkIds: null,
      continuous: this.continuous,
      occurrenceAmount:
        this.occurrenceAmount == null ? 0 : this.occurrenceAmount,
      occurrenceFrequency: this.occurrenceFrequency.name,
      achievementTarget: this.achievementTarget,
      achievementCondition: this.achievementCondition.name,
      achievementThreshold: this.achievementThreshold,
      user: this.user,
    };
    return payload;
  }

  checkIntegrity(targetIds) {
    return false;
  }

  static complete = (goal: ObservationGoalShape) => {
    let results = [
      goal.achievementCondition,
      goal.achievementTarget,
      goal.achievementThreshold,
      goal.continuous ? true : goal.occurrenceAmount,
      goal.measurementId,
      goal.occurrenceFrequency,
    ];

    if (results.includes(null) || goal.name == "") {
      return false;
    } else {
      return true;
    }
  };
}
